import React from "react";
import { makeStyles, Grid } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: ({ fontSize }) => fontSize,
    color: "#9ACEFF",
    fontWeight: ({ fontWeight }) => fontWeight,
    lineHeight: ({ lineHeight }) => `${lineHeight}px`,
    whiteSpace: ({ whiteSpace }) => whiteSpace,
  },
}));

const DashboardTitle = ({
  text = "",
  fontSize = 16,
  fontWeight = 400,
  lineHeight,
  variant = "primary",
  whiteSpace,
  color=""
}) => {
  const classes = useStyles({
    fontSize,
    fontWeight,
    variant,
    lineHeight,
    whiteSpace,
  });
  return <Grid item ><p className={classes.title} style={{ textAlign: 'justify', color: color }}>{text}</p></Grid>
};

export default DashboardTitle;
